import { SERVICES } from 'src/config/constants'
import { Loader } from 'src/utils/loader'

class SignalRLoader extends Loader {}

export const signalRLoader = new SignalRLoader({
  service: SERVICES.signalR,
})
